import { createSharedComposable, useBroadcastChannel, whenever } from "@vueuse/core";
import { newGuid } from "@/common/lib/string";

const tabId = newGuid();

interface LogoutMessage {
  tabId: string;
  logout: true;
}

function useLogoutBroadcastFn() {
  const { post, data } = useBroadcastChannel<LogoutMessage, LogoutMessage>({ name: "axure-cloud-logout" });
  whenever(data, message => {
    // Ignore messages from the same tab
    if (message.tabId === tabId) {
      return;
    }
    window.location.reload();
  });

  function postLogout() {
    post({
      tabId,
      logout: true,
    });
  }

  return {
    postLogout,
  };
}

export const useLogoutBroadcast = createSharedComposable(useLogoutBroadcastFn);
